export function formatCodMoney(value, currency = "USD", decimalDigits) {
  let digits = Number(decimalDigits);
  if (decimalDigits == null || !Number.isInteger(digits) || digits < 0 || digits > 4) {
    try {
      digits = new Intl.NumberFormat("en", { style: "currency", currency })
        .resolvedOptions().maximumFractionDigits;
    } catch {
      digits = 2;
    }
  }
  const match = String(value ?? "").trim().match(/^(-?)(\d+)(?:\.(\d+))?$/);
  if (!match) return String(value ?? "");
  const fraction = (match[3] || "").padEnd(digits + 1, "0");
  let minor = (match[2] + fraction.slice(0, digits)).replace(/^0+(?=\d)/, "");
  if (fraction[digits] >= "5") {
    const chars = minor.split("");
    let index = chars.length - 1;
    while (index >= 0 && chars[index] === "9") chars[index--] = "0";
    if (index < 0) chars.unshift("1");
    else chars[index] = String(Number(chars[index]) + 1);
    minor = chars.join("");
  }
  const padded = minor.padStart(digits + 1, "0");
  const amount = digits === 0 ? padded : `${padded.slice(0, -digits)}.${padded.slice(-digits)}`;
  return `${match[1] && /[1-9]/.test(minor) ? "-" : ""}${amount}`;
}
